import api from "../../services/api";
import { store } from "../../store/index";
import { LoginActions } from "../../store/ducks/application/login/login";
import { MxAlertaActions } from "../../store/ducks/components/mxalerta/mxalerta";
import { VistoriaActions } from "../../store/ducks/application/CarregaDescarregaContainer/vistoria";
import { AvariasActions } from "../../store/ducks/application/CarregaDescarregaContainer/listaAvarias";
import { AvariasOEAActions } from "../../store/ducks/application/CarregaDescarregaContainer/listaAvariasOEA";
import { LacresActions } from "../../store/ducks/application/CarregaDescarregaContainer/lacre";
import { CarregaGateActions } from "../../store/ducks/application/CarregaDescarregaContainer/carregaGate";
import { DescarregaGateActions } from "../../store/ducks/application/CarregaDescarregaContainer/descarregaGate";
import { DetalheCarregaGateActions } from "../../store/ducks/application/CarregaDescarregaContainer/detalheCarregaGate";
import { DetalheDescarregaGateActions } from "../../store/ducks/application/CarregaDescarregaContainer/detalheDescarregaGate";
import { DetalheGateActions } from "../../store/ducks/application/CarregaDescarregaContainer/detalheGate";
import { DetalheISOActions } from "../../store/ducks/application/CarregaDescarregaContainer/detalheISO";
import { RemocaoActions } from "../../store/ducks/application/remocao/remocao";
import { ControleReeferActions } from "../../store/ducks/application/controleReefer/controleReefer";
import { ConsultasGeraisActions } from "../../store/ducks/application/ConsultasGerais/consultasGerais";
import { MxNavigationBarActions } from "../../store/ducks/components/NavigationBar/navigationBar";
import { AutorizarEntradaActions } from "../../store/ducks/application/CarregaDescarregaContainer/autorizarEntrada";
import LegacySessionStorageKeys from "./data/legacySessionStorageKeys.json";
import { SolServActions } from "../../store/ducks/application/SolServ/SolServ";
import { EnumTiposEtiqueta } from "../mxenumerados";
import { verificaTipoEtiqueta } from "./verificaTipoEtiqueta";

export * from "./verificaTipoEtiqueta";

export const MxUtils = {
    getDataAtual,
    getDataUSAFormat,
    getDataAtual_Texto,
    getDataExpiracaoToken,
    getDataExpiracaoToken_Texto,
    getToken,
    getObjectToken,
    atualizaToken,
    limparStorageLogin,
    getTerminalPorID,
    getIdUsuarioLogado,
    getNomeUsuarioLogado,
    getLoginUsuarioLogado,
    getHorasParaExpirarSenhaUsuario,
    alertaConfirm,
    closeAlertaConfirm,
    alertaSucesso,
    alertaErro,
    alertaInfo,
    limparSessionStorage: limparLegacySessionStorage,
    limparSessionStorageExcept,
    getIdTerminalSelecionado,
    getDigitoCTR,
    getNumeroCTR,
    clearMinimize,
    clearStateAppMinimize,
    validarAmbienteProducao,
    alterarSenha,
    validaCpf,
    formatBoundedNumberToLocaleString,
    isMobileDevice,
    converterNumeroFormatado,
    converterDataParaPtBr,
    getUniqueListBy,
    uuidv4,
    fetchDadosUsuario,
    getPrimeiroUltimoNome
};

export const nomeClasse = {
    Container: 3,
    Volume: 23,
    Etiqueta: 516,
    PlacaGate: 26,
    Servicos: 551
}

export const descricaoNomeClassePorId = (id) => {
    switch (id) {
        case 3:
            return 'Container';
        case 23:
            return 'Volume';
        case 26:
            return 'Placa/Gate';
        case 551:
            return 'Serviços';
        default:
            return '';
    }
}

export const skills = {
    Confere: 'Confere',
    ImagensEmGeral: 'ImagensEmGeral'
}

function getPrimeiroUltimoNome(fullName) {
    fullName = fullName.toLowerCase();

    let nameParts = fullName.split(' ');

    let firstName = nameParts[0];
    let lastName = nameParts[nameParts.length - 1];

    return firstName + '.' + lastName
}

async function fetchDadosUsuario(login) {
    const { data } = await api.get(`/IntramexService/api/Login/Get?login=` + login
    );

    return data
}

/**
 * Formata um número para o padrão pt-BR com um min/max de casas decimais
 * @param {number} number - Número a ser formatado
 * @param {number} boundary - Quantidade de casas decimais
 * @returns {string} - Em português
 */
function formatBoundedNumberToLocaleString(number, boundary = 2) {
    return number.toLocaleString("pt-BR", {
        minimumFractionDigits: boundary,
        maximumFractionDigits: boundary
    });
}

function getTerminalPorID(terminal) {
    switch (terminal) {
        case 15180:
            return "T2";
        case 242315:
            return "T5";
        case 270094:
            return "T8";
        default:
            return "";
    }
}

/**
 * **ESTÁ FUNÇÃO APENAS LIMPA O ESTADO DOS APPS LEGADOS**
 *
 * Opte por usar o método window.sessionStorage.removeItem(key) para especificar função de cleanup
 *
 * **Nunca utilize o método window.sessionStorage.clear()**
 * @deprecated
 */
function limparLegacySessionStorage() {
    LegacySessionStorageKeys.forEach(key => {
        sessionStorage.removeItem(key);
    });

    //sessionStorage.clear(); Causa bugs com a persistência de dados de outros apps
}

function limparSessionStorageExcept(except, comparer, removeAlvo) {
    if (
        (except === comparer && removeAlvo) ||
        except === "" ||
        comparer === "" ||
        except === undefined ||
        comparer === undefined ||
        except === null ||
        comparer === null
    ) {
        limparLegacySessionStorage();
    } else {
        const dataSessionStored = Object.entries(sessionStorage);

        if (dataSessionStored && dataSessionStored.length > 0) {
            dataSessionStored.forEach(function (item) {
                if (item[1] === except) {
                    return;
                }
                sessionStorage.removeItem(item[0]);
            });
        }
    }
}

function getDataAtual() {
    let data = new Date();
    return data;
}

function getDataUSAFormat() {
    let date = new Date();

    let day = date.getDate().toString();
    let month = date.getMonth() + 1;
    let year = date.getFullYear().toString();

    day = day.padStart(2, '0');
    month = month.toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
}

function getDataAtual_Texto() {
    return getDataAtual().toLocaleString();
}

function getDataExpiracaoToken() {
    const dataExpiracao = store.getState().loginreducer.DataExpiracao || "";

    return new Date(dataExpiracao);
}

function getDataExpiracaoToken_Texto() {
    let dataExpiracao = getDataExpiracaoToken();

    return dataExpiracao.toLocaleString();
}

async function atualizaToken(nome = "", valor = "") {
    let token = MxUtils.getToken();
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };
    let dadoAtualizado = await api.post(
        "/MarimexAuthentication/api/usuario/atualizar",
        { Nome: nome, Valor: valor },
        config
    );

    store.dispatch(LoginActions.AtualizarToken(dadoAtualizado.data.Token));
}

function getToken() {
    const state = store.getState();
    const token = state.loginreducer.Token;

    return token;
}

/**
 * @typedef {Object} ObjectToken
 * @property {string} nome
 * @property {string} login
 * @property {string} email
 * @property {string} cpf
 * @property {number} exp
 * @property {number} nbf
 * @property {number} iat
 * @property {string} usuariointranetid
 * @property {string} usuariointramexid
 * @property {string} pessoaid
 * @property {string} apelido
 * @property {string} validadesenha - dd/MM/yyyy HH:mm:ss
 * @property {string[]} app - Enum dos apps
 */
/**
 * @param {string} [token]
 * @returns {ObjectToken}
 */
function getObjectToken(token = getToken()) {
    if (!token) throw new Error("Token não encontrado");
    return /**@type {ObjectToken} */ (parseJwt(token));
}

/**
 *
 * @param {string} token
 * @returns {unknown}
 */
function parseJwt(token) {
    if (!token) return;

    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );

    return JSON.parse(jsonPayload);
}

function limparStorageLogin() {
    store.dispatch(LoginActions.Logout());
}

/**
 *
 * @returns {ObjectToken["login"]}
 */
function getLoginUsuarioLogado() {
    let state = store.getState();
    let token = state.loginreducer.Token;
    let objToken = MxUtils.getObjectToken(token);
    console.log(token);
    return objToken.login;
}

function getIdUsuarioLogado() {
    let state = store.getState();
    let token = state.loginreducer.Token;
    let objToken = MxUtils.getObjectToken(token);
    return objToken.pessoaid;
}
function getNomeUsuarioLogado() {
    let state = store.getState();
    let token = state.loginreducer.Token;
    let objToken = MxUtils.getObjectToken(token);
    return objToken.nome;
}

function getHorasParaExpirarSenhaUsuario() {
    let state = store.getState();
    let token = state.loginreducer.Token;
    let objToken = MxUtils.getObjectToken(token);

    let ano = objToken.validadesenha.substring(6, 10); //ano
    let mes = objToken.validadesenha.substring(3, 5); //mês
    let dia = objToken.validadesenha.substring(0, 2); //dia

    let hor = objToken.validadesenha.substring(11, 13); //hora
    let min = objToken.validadesenha.substring(14, 16); //minuto
    let seg = objToken.validadesenha.substring(17, 19); //segundo

    let dataValidade = new Date(`${ano}-${mes}-${dia}T${hor}:${min}:${seg}`);
    let hoje = new Date();

    return (dataValidade.getTime() - hoje.getTime()) / 3600000;
}

function getIdTerminalSelecionado() {
    let state = store.getState();
    let terminalId = state.loginreducer.Terminal;
    return terminalId;
}

function alertaConfirm(title, question, yesClick, noClick) {
    if (noClick === undefined)
        store.dispatch(
            MxAlertaActions.ExecutarConfirm(
                title,
                question,
                yesClick,
                closeAlertaConfirm
            )
        );
    else
        store.dispatch(
            MxAlertaActions.ExecutarConfirm(title, question, yesClick, noClick)
        );
}

function closeAlertaConfirm() {
    store.dispatch(MxAlertaActions.ExecutarClose());
}

function alertaSucesso(mensagem) {
    store.dispatch(MxAlertaActions.Executar(mensagem, "success"));
}

function alertaErro(mensagem) {
    store.dispatch(
        MxAlertaActions.Executar(
            mensagem || "Ocorreu um erro inesperado.",
            "error"
        )
    );
}

function alertaInfo(mensagem) {
    store.dispatch(MxAlertaActions.Executar(mensagem, "info"));
}

function getDigitoCTR() {
    let state = store.getState();
    let container = state.vistoriareducer.PassagemContainerNumero;

    if (container.length > 12) {
        let difitoContainer = container.substr(13, 1);
        return difitoContainer;
    } else {
        return;
    }
}

function getNumeroCTR() {
    let state = store.getState();
    let container = state.vistoriareducer.PassagemContainerNumero;

    if (container.length >= 12) {
        let difitoContainer = container.substr(0, 12);
        return difitoContainer;
    } else {
        return;
    }
}

function clearMinimize(nomeApp) {
    let state = store.getState();
    let stateNavigationBar = state.navigationBarreducer;

    // @ts-ignore
    let appsMinimized = stateNavigationBar.Aplicativos;

    let grupoCarrDesc = [
        "Carrega Descarrega Container",
        "Operações de Pátio",
        "Vistoria",
        "Avarias",
        "Lacres",
        "Avarias OEA",
        "Pickup",
        "Remoção",
        "Posicionar",
        "Carregamento de Veículo",
        "Descarga de Veículo",
        "Carrega Gate",
        "Interrupção",
        "Descarrega Gate",
        "Detalhes do Gate",
        "Autorizar Entrada"
    ];
    let grupoReefer = [
        "Controle Reefer",
        "Leituras Pendentes",
        "Registrar Leitura"
    ];
    let grupoTurno = ["Habilita Turno"];
    let grupoConsultasGerais = ["Consultas Gerais", "Consultas Gerais Mobile"];
    let grupoSolServEstufagem = ["Sol Serv", "Itens Estufagem", "Volume"];
    let grupoImagensApp = ["ImagensApp",
        "Selecione o Tipo",
        "imagensapp",
        "Imagens em Geral",
        "confere",
        "consulta",
        "confirmaimagem",
        "confirmarimagem",
        "imagensemgeral",
        "Consulta - Container",
        "Consulta - Volume",
        "Consulta - Etiqueta",
        "Consulta - Placa Gate",
        "Tipo Imagem - Container",
        "Tipo Imagem - Volume",
        "Tipo Imagem - Etiqueta",
        "Confirmar Imagem"
    ];

    if (grupoCarrDesc.includes(nomeApp)) {
        let minimizeApp = appsMinimized.filter(
            el => !grupoCarrDesc.includes(el.NomeApp)
        );

        store.dispatch(MxNavigationBarActions.resetNavigationBarState());
        store.dispatch(MxNavigationBarActions.minimize(minimizeApp));
    } else if (grupoReefer.includes(nomeApp)) {
        let minimizeApp = appsMinimized.filter(
            el => !grupoReefer.includes(el.NomeApp)
        );

        store.dispatch(MxNavigationBarActions.resetNavigationBarState());
        store.dispatch(MxNavigationBarActions.minimize(minimizeApp));
    } else if (grupoTurno.includes(nomeApp)) {
        let minimizeApp = appsMinimized.filter(
            el => !grupoTurno.includes(el.NomeApp)
        );

        store.dispatch(MxNavigationBarActions.resetNavigationBarState());
        store.dispatch(MxNavigationBarActions.minimize(minimizeApp));
    } else if (grupoConsultasGerais.includes(nomeApp)) {
        let minimizeApp = appsMinimized.filter(
            el => !grupoConsultasGerais.includes(el.NomeApp)
        );

        store.dispatch(MxNavigationBarActions.resetNavigationBarState());
        store.dispatch(MxNavigationBarActions.minimize(minimizeApp));
    } else if (grupoSolServEstufagem.includes(nomeApp)) {
        let minimizeApp = appsMinimized.filter(
            el => !grupoSolServEstufagem.includes(el.NomeApp)
        );

        store.dispatch(MxNavigationBarActions.resetNavigationBarState());
        store.dispatch(MxNavigationBarActions.minimize(minimizeApp));
    } else if (grupoImagensApp.includes(nomeApp)) {
        let minimizeApp = appsMinimized.filter(
            el => !grupoImagensApp.includes(el.NomeApp)
        );

        store.dispatch(MxNavigationBarActions.resetNavigationBarState());
        store.dispatch(MxNavigationBarActions.minimize(minimizeApp));
    }
    return;
}

function clearStateAppMinimize(nomeApp) {
    let grupoCarrDesc = [
        "Carrega Descarrega Container",
        "Operações de Pátio",
        "Vistoria",
        "Avarias",
        "Lacres",
        "Avarias OEA",
        "Pickup",
        "Remoção",
        "Posicionar",
        "Carregamento de Veículo",
        "Descarga de Veículo",
        "Carrega Gate",
        "Interrupção",
        "Descarrega Gate",
        "Detalhes do Gate",
        "Autorizar Entrada"
    ];
    let grupoReefer = [
        "Controle Reefer",
        "Leituras Pendentes",
        "Registrar Leitura"
    ];
    let grupoTurno = ["Habilita Turno"];
    let grupoConsultasGerais = ["Consultas Gerais", "Consultas Gerais Mobile"];
    let grupoSolServEstufagem = ["Sol Serv", "Itens Estufagem", "Volume"];
    let grupoImagensApp = ["ImagensApp",
        "Selecione o Tipo",
        "Consulta - Container",
        "Consulta - Volume",
        "Consulta - Etiqueta",
        "Consulta - Placa Gate",
        "Tipo Imagem - Container",
        "Tipo Imagem - Volume",
        "Tipo Imagem - Etiqueta",
        "Confirmar Imagem"
    ];

    if (grupoCarrDesc.includes(nomeApp)) {
        store.dispatch(VistoriaActions.resetState());
        store.dispatch(AvariasActions.resetState());
        store.dispatch(AvariasOEAActions.resetState());
        store.dispatch(LacresActions.resetLacresState());
        store.dispatch(CarregaGateActions.resetStateCarregaGate());
        store.dispatch(DescarregaGateActions.resetStateDescarregaGate());
        store.dispatch(DetalheCarregaGateActions.resetStateDetalheCarrega());
        store.dispatch(
            DetalheDescarregaGateActions.resetStateDetalheDescarrega()
        );
        store.dispatch(DetalheISOActions.resetState());
        store.dispatch(RemocaoActions.resetRemocaoState());
        store.dispatch(DetalheGateActions.resetStateDetalheGate());
        store.dispatch(AutorizarEntradaActions.resetStateAutorizarEntrada());
    } else if (grupoReefer.includes(nomeApp)) {
        store.dispatch(ControleReeferActions.resetControleReeferState());
    } else if (grupoTurno.includes(nomeApp)) {
    } else if (grupoConsultasGerais.includes(nomeApp)) {
        store.dispatch(ConsultasGeraisActions.resetStateConsultasGerais());
    } else if (grupoSolServEstufagem.includes(nomeApp)) {
        store.dispatch(SolServActions.resetStateSolServ());
    } else if (grupoImagensApp.includes(nomeApp)) {
        //TODO
    }
    else if (nomeApp === "*") {
        store.dispatch(VistoriaActions.resetState());
        store.dispatch(AvariasActions.resetState());
        store.dispatch(AvariasOEAActions.resetState());
        store.dispatch(LacresActions.resetLacresState());
        store.dispatch(CarregaGateActions.resetStateCarregaGate());
        store.dispatch(DescarregaGateActions.resetStateDescarregaGate());
        store.dispatch(DetalheCarregaGateActions.resetStateDetalheCarrega());
        store.dispatch(
            DetalheDescarregaGateActions.resetStateDetalheDescarrega()
        );
        store.dispatch(DetalheISOActions.resetState());
        store.dispatch(RemocaoActions.resetRemocaoState());
        store.dispatch(ControleReeferActions.resetControleReeferState());
        store.dispatch(DetalheGateActions.resetStateDetalheGate());
        store.dispatch(ConsultasGeraisActions.resetStateConsultasGerais());
        store.dispatch(AutorizarEntradaActions.resetStateAutorizarEntrada());
        store.dispatch(SolServActions.resetStateSolServ());

        store.dispatch(MxNavigationBarActions.resetNavigationBarState());
    }
    return;
}

function validarAmbienteProducao() {
    // @ts-ignore
    return !(process.env.REACT_APP_AMBIENTE_HOMOLOGACAO === "true");
}

/**
 *
 * @param {string} login
 * @param {string} senhaAtual
 * @param {string} senhaNova
 * @returns
 */
async function alterarSenha(login, senhaAtual, senhaNova) {
    let response = await api.post("/IntramexService/api/Login/AlterarSenha", {
        Login: login,
        SenhaAtual: senhaAtual,
        SenhaNova: senhaNova
    });
    return response;
}

function validaCpf(cpf) {
    cpf = cpf.replace(/[^a-z0-9]/gi, "");

    if (cpf) {
        let numbers, digits, sum, i, result, equalDigits;
        equalDigits = 1;
        if (cpf.length < 11) {
            return false;
        }

        for (i = 0; i < cpf.length - 1; i++) {
            if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
                equalDigits = 0;
                break;
            }
        }

        if (!equalDigits) {
            numbers = cpf.substring(0, 9);
            digits = cpf.substring(9);
            sum = 0;
            for (i = 10; i > 1; i--) {
                sum += numbers.charAt(10 - i) * i;
            }

            result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

            if (result !== Number(digits.charAt(0))) {
                return false;
            }
            numbers = cpf.substring(0, 10);
            sum = 0;

            for (i = 11; i > 1; i--) {
                sum += numbers.charAt(11 - i) * i;
            }
            result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

            if (result !== Number(digits.charAt(1))) {
                return false;
            }
            return true;
        } else {
            return false;
        }
    }
}

function isMobileDevice() {
    let userAgent = window.navigator.userAgent.toUpperCase();
    return !userAgent.includes("WINDOWS");
}

function converterNumeroFormatado(etiqueta) {
    if (verificaTipoEtiqueta(etiqueta) === EnumTiposEtiqueta.NaoFormatado) {
        let etiquetaSplit = etiqueta.split('$')[1];
        return parseInt(etiquetaSplit, 16)
    } else {
        return etiqueta;
    }
}

function converterDataParaPtBr(dataString) {

    if (dataString) {

        // Dividir a string da data em ano, mês e dia
        let partesData = dataString.split("-");
        let ano = partesData[0];
        let mes = partesData[1];
        let dia = partesData[2].split("T")[0];
        let dataPtBr = dia + "/" + mes + "/" + ano;

        return dataPtBr;
    } else {
        return null;
    }
}

function getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key].split('|')[0], item])).values()]
}

export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
        .replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0,
                v = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
}

export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));